<template>
  <div
    v-show="shouldShowSection"
    class="animated"
    v-bind:class="[shouldSlideIn ? 'fadeIn' : 'fadeOut']"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "GuiideTransitionShallow",
  props: {
    sectionVisible: { type: Boolean, required: true },
    slideIn: { type: Boolean, required: true }
  },
  computed: {
    shouldShowSection: function(): boolean {
      return this.sectionVisible;
    },
    shouldSlideIn: function(): boolean {
      return this.slideIn;
    }
  }
});
</script>

<style scoped>
.animated {
  opacity: 0;
  height: 0;
  
  overflow: hidden;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animated:not(.fadeIn) {
  pointer-events: none;
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
    height: 0;
  }
  100% {
    opacity: 1;
    height: 106px;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    height: 0;
  }
  100% {
    opacity: 1;
    height: 106px;
  }
}

@-webkit-keyframes fadeOut {
  0% {
    opacity: 1;
    height: 106px;
  }
  100% {
    opacity: 0;
    height: 0;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
    height: 106px;
  }
  100% {
    opacity: 0;
    height: 0;
  }
}

.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}

.fadeOut {
  -webkit-animation-name: fadeOut;
  animation-name: fadeOut;
  -webkit-animation-fill-mode: backwards;
  animation-fill-mode: backwards;
}
</style>
